import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'ng2-app/http/clients/api';
import { FlashSpreadDocumentData } from 'ng2-app/models/documents/FlashSpreadDocumentData.struct';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FlashSpreadService {
  constructor(
    private http: ApiHttpClient,
  ) {}

  getFlashSpreadData(borrowerId: number): Observable<FlashSpreadDocumentData[]> {
    return this.http.get<FlashSpreadDocumentData[]>(`${environment.API_URL}/documents/flashSpreadData/${borrowerId}`);
  }
}